export const renderFieldConditionally = (
  fields: string[] | [] = [],
  fieldName: string,
): boolean =>
  !!fields?.some((item) => item.toLowerCase() === fieldName.toLowerCase());
